import { useSelector } from "react-redux";
import { FilterTemplate } from "./FilterTemplate";

interface InsightTypeFilterProps {
	innerRef: React.RefObject<{
		getFilters: () => string[];
	}>;
	handleApply: () => void;
}

export const InsightTypeFilter: React.FC<InsightTypeFilterProps> = ({ innerRef, handleApply }) => {
	const insightTypes = useSelector((state: any) => state.libraries?.insightTypes) as any[] | undefined;

	return <FilterTemplate innerRef={innerRef} records={insightTypes} title="INSIGHT_TYPES" icon="hashtag" handleApply={handleApply} />;
};
